import { TKey } from "@/app/translations/TKey";
import { BlogCategory } from "@/app/types/BlogCategory";
import { CATEGORY_IDS_WITH_ARTICLES } from "../BlogArticles/BlogArticles.logic";

export const BLOG_CATEGORY_ALL = "all";

export type BlogCategoryItem = {
  id: string;
  labelKey: TKey;
  disabled: boolean;
};

const BLOG_CATEGORY_LABEL: Record<BlogCategory, TKey> = {
  [BlogCategory.CALL_ANALYSIS]: TKey.BLOG_CAT_CALL_ANALYSIS,
  [BlogCategory.CUSTOMER_KNOWLEDGE]: TKey.BLOG_CAT_CUSTOMER_KNOWLEDGE,
  [BlogCategory.WIN_LOSS]: TKey.BLOG_CAT_WIN_LOSS,
  [BlogCategory.AI_TOOLS]: TKey.BLOG_CAT_AI_TOOLS,
};

export const BLOG_CATEGORIES: BlogCategoryItem[] = [
  { id: BLOG_CATEGORY_ALL, labelKey: TKey.BLOG_CAT_ALL, disabled: false },
  ...Object.values(BlogCategory).map((category) => ({
    id: category,
    labelKey: BLOG_CATEGORY_LABEL[category],
    disabled: !CATEGORY_IDS_WITH_ARTICLES.has(category),
  })),
];

export function getCategoryLabelKey(id: string): TKey | undefined {
  return BLOG_CATEGORIES.find((category) => category.id === id)?.labelKey;
}
